import { render, staticRenderFns } from "./toggle-facets-group.vue?vue&type=template&id=5ae528d0&"
import script from "./toggle-facets-group.vue?vue&type=script&lang=ts&"
export * from "./toggle-facets-group.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports